import * as model from "./model.js";
import recipeView from "./views/recipeView.js";
import searchView from "./views/searchView.js";
import resultsView from "./views/resultView.js";
import paginationView from "./views/paginationView.js";
import bookmarksView from "./views/bookmarksView.js";
import addRecipeView from "./views/addRecipeView.js";
import { MODAL_CLOSE_SEC } from "./config.js";
const recipeContainer = document.querySelector(".recipe");

/*const renderSpinner = function (parentEl) {
  const markup = `<div class="spinner">
  <svg>
    <use href="src/img/icons.svg#icon-loader"></use>
  </svg>
</div> `;
  parentEl.innerHTML = "";
  parentEl.insertAdjacentHTML("afterbegin", markup);
};*/
const controlRecipe = async function () {
  try {
    const id = window.location.hash.slice(1);
    //console.log(id);

    if (!id) return;
    recipeView.renderSpinner();
    //1)loading recipe
    //mark selected search results
    resultsView.update(model.getSearchResultPage());
    // bookmarksView.update(model.state.bookmarks);

    await model.loadRecipe(id);
    //const { recipe } = model.state;

    //2)rendering recipe
    recipeView.render(model.state.recipe);

    //bookmarksView.update(model.state.bookmarks);
  } catch (err) {
    //console.log(err);
    recipeView.renderError();
  }
};
const controlSearchResult = async function () {
  try {
    resultsView.renderSpinner();
    //get search query
    const query = searchView.getQuery();
    if (!query) return;
    //load search results
    await model.loadSearchResult(query); //render results
    //console.log(model.state.search.results);
    //resultView.render(model.state.search.results)
    //console.log(model.getSearchResultPage(2));
    resultsView.render(model.getSearchResultPage());
    //render initial pagination buttons
    paginationView.render(model.state.search);
  } catch (err) {
    console.error(err);
  }
};
//["hashchange", "load"].forEach((ev) => window.addEventListener(ev, showRecipe));
//controlSearchResult();

const controlPagination = function (goToPage) {
  //render new results
  resultsView.render(model.getSearchResultPage(goToPage));
  paginationView.render(model.state.search);
  console.log(goToPage);
};
const controlServings = function (newServings) {
  //update the recipe servings(state)
  model.updateServings(newServings);
  recipeView.update(model.state.recipe);

  //update the recipeview
};

const controlAddBookmark = function () {
  //add or remove bookmark
  if (!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);
  //model.addBookmark(model.state.recipe);
  //console.log(model.state.recipe);

  //update recipeView
  recipeView.update(model.state.recipe);

  bookmarksView.render(model.state.bookmarks);

  bookmarksView.update(model.state.bookmarks);
};

const controlBookmarks = function () {
  bookmarksView.render(model.state.bookmarks);
};

const controlAddRecipe = async function (newRecipe) {
  try {
    addRecipeView.renderSpinner();
    //console.log(newRecipe);
    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);
    //render recipe
    recipeView.render(model.state.recipe);
    //success message
    addRecipeView.renderMessage();

    //render bookmarkview
    bookmarksView.render(model.state.bookmarks);
    window.history.pushState(null, "", `#${model.state.recipe.id}`);
    //close form after submit
    setTimeout(function () {
      addRecipeView.toggleWindow();
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    // console.error(err);
    addRecipeView.renderError(err.message);
  }
};

const init = function () {
  bookmarksView.addHandlerRender(controlBookmarks);
  recipeView.addHandlerRender(controlRecipe);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark);
  searchView.addHandlerSearch(controlSearchResult);
  paginationView.addHandlerClick(controlPagination);
  addRecipeView.addHandlerUpload(controlAddRecipe);
};
init();
//window.addEventListener("hashchange", showRecipe());
